<template>
    <VContainer>
        <VLayout wrap>
            <VFlex xs12>
                <BaseCard>
                    <VCardTitle>
                       Textappy Beta  v{{$store.state.version}}
                        <v-spacer></v-spacer>
                        <span v-if="$store.state.org">
                           {{$store.state.org.info.fullname}}
                        </span>
                    </VCardTitle>
                    <VCardText>
                        Go to Accounts and Settings
                        <BaseBtn to="/account" text><v-icon>fas fa-cogs</v-icon></BaseBtn>
                        to set up your app.<br/>
                        Or View your dashboard
                        <BaseBtn text to="/dashboard"><v-icon>{{$store.state.icons.dashboard}}</v-icon></BaseBtn>
                        <v-divider></v-divider>
                    </VCardText>
                </BaseCard>
            </VFlex>
        </VLayout>
    </VContainer>
</template>

<script>
  import BaseBtn from "@/components/BaseBtn";
  export default {
    components: {BaseBtn},
    name: "HomePage",
    data() {
      return {}
    },
    mounted() {
    },
    methods: {
      remvIndex(){
        this.$store.dispatch('removeNtfs',{code:'apporg'})
      },
    }
  }
</script>

<style scoped>

</style>